/**
 * Light haptic feedback for Capacitor (mobile). No-op on web.
 */
type CapacitorHaptics = {
  impact: (opts: { style: string }) => Promise<void>;
  notification: (opts: { type: string }) => Promise<void>;
};

type CapacitorWindow = Window & {
  Capacitor?: { Plugins?: { Haptics?: CapacitorHaptics } };
};

function getHaptics(): CapacitorHaptics | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as CapacitorWindow).Capacitor?.Plugins?.Haptics;
}

export function lightHaptic(): void {
  const h = getHaptics();
  if (!h) return;
  void h.impact({ style: 'LIGHT' }).catch(() => {});
}

export function successHaptic(): void {
  const h = getHaptics();
  if (!h) return;
  void h.notification({ type: 'SUCCESS' }).catch(() => {});
}
